(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Update cart property input with limited drop message if it exists
    const limitedDropElements = document.querySelectorAll('[data-limited-drop-message]');
    limitedDropElements.forEach(function(element) {
      const message = element.dataset.limitedDropMessage;
      if (message) {
        const form = element.closest('form');
        if (form) {
          const cartPropertyInput = form.querySelector('input[data-limited-drop-cart-note]');
          if (cartPropertyInput) {
            cartPropertyInput.value = message;
          }
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
